import React from "react";
import { initialsFor } from "../../utils/displayName";

interface IosAvatarProps {
  name: string;
  size: number;
}

const IosAvatar: React.FC<IosAvatarProps> = ({ name, size }) => {
  const initials = initialsFor(name);
  return (
    <div
      className="ios-avatar"
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      aria-hidden="true"
    >
      {initials || (
        <svg width={size * 0.62} height={size * 0.62} viewBox="0 0 24 24">
          <circle cx="12" cy="8" r="4.5" fill="#ffffff" />
          <path d="M3 22c0-5 4-8 9-8s9 3 9 8z" fill="#ffffff" />
        </svg>
      )}
    </div>
  );
};

export default IosAvatar;
